import { REPORT_FILTER_PERIODS } from "../consts/reportFilterPeriodConsts";
//! @ngInject
export function filterFieldValue(itemSearchPageManager, DatabaseApi) {
    return {
      restrict: "E",
      transclude: true,

      templateUrl: "admin/views/filter-field-value-directive.html",
      scope: {
        filter: "=",
        allFilters: "=?"
      },
      link: function($scope, $rootScope) {
        $scope.customListSelectionSettings = {
          styleActive: true,
          singleSelection: true,
          selectionLimit: 1,
          smartButtonMaxItems: 1,
          closeOnSelect: true,
          showCheckAll: false,
          showUncheckAll: false
    };
        var scope = $scope;
        $scope.filterEvents = {
          onItemSelect: function (item) {
            // alert(1);


            if (item['$selectedModel']){
              item.value = [];
              for (let j = 0; j < item['$selectedModel'].length; j++) {
                  let selectedArrayItem = item["$selectedModel"][j];
                  item.value.push(selectedArrayItem.id);
              }
              if (item.value.length === 0){
                  filters.splice(i);
              }
          }
          },
          onItemDeselect(item) {

              // $scope.selectedPendingCertificationLabel = null;
          },
          onDeselectAll() {
              // $scope.selectedPendingCertificationLabel = null;
          }
      }

        this.sortableOptions = {
          handle: '> .myHandle'
        }
        this.hideValueOperators = ['IS NULL', 'NOT IS NULL'];
        this.altInputFormats = ['MM/dd/yyyy'];
        this.datePickerOptions = {
          locale: {
            format: "MM/DD/YYYY",
          },
          startingDay: "Sunday"
        };
        this.timePeriodOptions = REPORT_FILTER_PERIODS.single;
        this.timePeriodIntervalOptions = REPORT_FILTER_PERIODS.counted;
        this.timePeriodRelativeIntervalOptions = REPORT_FILTER_PERIODS.relative;
        this.timePeriodOperators = ["LAST X", "THIS X", "NEXT X", "LAST N X", "NEXT N X"];
        this.timePeriodIntervalOperators = ["LAST N X", "NEXT N X"];
        this.timePeriodRelativeIntervalOperators = ["LAST REL N X", "NEXT REL N X"];
        this.nowRelativeTimeComparisonOperator = "NOW REL TIME COMPARE";

        this.showOperator = (operator) => {
          return (
            // Not hidden operator
            !(
              operator.logicalOperator === this.nowRelativeTimeComparisonOperator
              || this.timePeriodRelativeIntervalOperators.includes(operator.logicalOperator)
            )
            // Or is hidden operator and is onboarding agency
            || $rootScope.isOnboardingAgency
          )
        }


        this.handleRemoveFilter = (index, tableName, columnName) => {
          this.onRemoveFilter({
            index,
            tableName,
            columnName
          });
        }


        this.handleFilterClicked = (filter) => {


          const tableName = filter.tableName;


          this.onFilterClicked({
            tableName,
            filter
          })
        }

        this.handleTimePeriodChange = (filter) => {
          if (this.isTimePeriodValid(filter)) {
            filter.value = `${filter.timePeriodValue.interval} ${filter.timePeriodValue.timePeriod}`;
          } else {
            filter.value = "";
          }
        }
        this.isTimePeriodValid = (filter) => {
          return (filter.timePeriodValue.interval !== undefined && filter.timePeriodValue.interval !== null &&
            filter.timePeriodValue.timePeriod !== undefined && filter.timePeriodValue.timePeriod !== "")
        }
        this.handleFilterDescriptionClick = () => {
          // this.onFilterDescriptionClick();
        }
        scope.altInputFormats = ['MM/dd/yyyy'];
        scope.datePickerOptions = {
          locale: {
            format: "MM/DD/YYYY",
          },
          startingDay: "Sunday"
        };
        scope.hideValueOperators = ['IS NULL', 'NOT IS NULL'];

        scope.timePeriodOptions = REPORT_FILTER_PERIODS.single;
        scope.timePeriodIntervalOptions = REPORT_FILTER_PERIODS.counted;
        scope.timePeriodRelativeIntervalOptions = REPORT_FILTER_PERIODS.relative;
        scope.timePeriodOperators = ["LAST X", "THIS X", "NEXT X", "LAST N X", "NEXT N X"];
        scope.timePeriodIntervalOperators = ["LAST N X", "NEXT N X"];
        scope.timePeriodRelativeIntervalOperators = ["LAST REL N X", "NEXT REL N X"];
        scope.nowRelativeTimeComparisonOperator = "NOW REL TIME COMPARE";

        scope.yearsOptionsExtraSettings = {
          displayProp: "name",
          styleActive: true,
          scrollable: true,
          scrollableHeight: '150px',
          selectionLimit: 1,
          smartButtonMaxItems: 1,
          closeOnSelect: true,
          showCheckAll: false,
          showUncheckAll: false
      };

      scope.reactFilterValue = null;

      scope.reactFilterOnChange = (value) => {
        scope.reactFilterValue = value === null ? null : value.id;
        scope.filter.value = value === null ? [] : [value.id];
        scope.$digest();
      }

        const generateArrayOfYears = () => {
          var max = new Date().getFullYear();
          var min = 2019;
          var years = []
        
          for (var i = max; i >= min; i--) {
            years.push({
              id: i,
              name: i
            });
          }

          return years;
        }

        scope.yearOptions = generateArrayOfYears();

        scope.locationSelectionSettings = {
          styleActive: true,
          scrollable: true,
          scrollableHeight: '200px',
          smartButtonMaxItems: 3,
          showCheckAll: true,
          showUncheckAll: true,
          enableSearch: true
        };

        const flattenCounties = () => {
          const countyGroups = DatabaseApi.counties() || [];
          const counties = [];
          for (const group of countyGroups) {
            if (!group.counties) continue;
            for (const c of group.counties) {
              counties.push({ state: c.state, countyName: c.countyName });
            }
          }
          return counties;
        };

        const findSiblingFilterValues = (srcType) => {
          if (!scope.allFilters) return null;
          const sibling = scope.allFilters.find((f) => f && f.srcType === srcType && f !== scope.filter);
          if (!sibling) return null;
          let val = sibling.value;
          if (val && !Array.isArray(val) && Array.isArray(val.value)) {
            val = val.value;
          }
          if (!Array.isArray(val) || val.length === 0) return null;
          return val.map((v) =>
            v != null && typeof v === "object" && "id" in v ? v.id : v
          );
        };

        let stateOptionsCache = null;
        let stateOptionsCacheLen = -1;
        scope.getStateOptions = () => {
          const counties = DatabaseApi.counties() || [];
          if (stateOptionsCache !== null && counties.length === stateOptionsCacheLen) {
            return stateOptionsCache;
          }
          const states = new Set();
          for (const c of flattenCounties()) {
            states.add(c.state);
          }
          stateOptionsCache = [...states].sort().map((s) => ({ id: s, label: s }));
          stateOptionsCacheLen = counties.length;
          return stateOptionsCache;
        };

        let countyOptionsCache = null;
        let countyOptionsCacheKey = null;
        scope.getCountyOptions = () => {
          const counties = DatabaseApi.counties() || [];
          const selectedStates = findSiblingFilterValues("STATE");
          const key =
            counties.length +
            "|" +
            (selectedStates ? selectedStates.slice().sort().join(",") : "*");
          if (countyOptionsCache !== null && countyOptionsCacheKey === key) {
            return countyOptionsCache;
          }
          const seen = new Set();
          const options = [];
          for (const c of flattenCounties()) {
            if (selectedStates && selectedStates.indexOf(c.state) === -1) continue;
            if (seen.has(c.countyName)) continue;
            seen.add(c.countyName);
            options.push({ id: c.countyName, label: c.countyName + ", " + c.state });
          }
          countyOptionsCache = options.sort((a, b) => a.label.localeCompare(b.label));
          countyOptionsCacheKey = key;
          return countyOptionsCache;
        };

        let payerOptionsCache = null;
        let payerOptionsCacheLen = -1;
        scope.getPayerOptions = () => {
          const payers = DatabaseApi.payers() || [];
          if (payerOptionsCache !== null && payers.length === payerOptionsCacheLen) {
            return payerOptionsCache;
          }
          payerOptionsCache = payers
            .filter((p) => p && p.isActive)
            .map((p) => ({ id: p.id, label: p.name }))
            .sort((a, b) => a.label.localeCompare(b.label));
          payerOptionsCacheLen = payers.length;
          return payerOptionsCache;
        };

        var initPageManager = function () {
          $scope.pageManager = itemSearchPageManager.createSearchPageManager("");
          $scope.validatorsDataManager = $scope.pageManager.getValidatorsDataManager();

          $scope.officeDataManager = $scope.pageManager.getOfficeDataManager();
          $scope.contractTypesDataManager = $scope.pageManager.getContractTypesDataManager();
          $scope.serviceCodesDataManager = $scope.pageManager.getServiceCodesDataManager();
          $scope.payCodesDataManager = $scope.pageManager.getPayCodesDataManager();
          $scope.certificationDataManager = $scope.pageManager.getCertificationDataManager();
          $scope.patientStatusesDataManager = $scope.pageManager.getPatientStatusesDataManager();
          $scope.caregiverStatusesDataManager = $scope.pageManager.getCaregiverStatusesDataManager();
          $scope.teamDataManager = $scope.pageManager.getTeamDataManager();
          $scope.coordinatorDataManager = $scope.pageManager.getCoordinatorDataManager({onlyActive: true});
          $scope.pageManager.initFromToDateParams();
          $scope.pageManager.initContractTypesParam();
          $scope.pageManager.initServiceCodesParam();
          $scope.pageManager.initOfficeParam();
          $scope.pageManager.initTeamParam();
          $scope.pageManager.initCoordinatorParam();
          $scope.pageManager.initSearchParam("officeId", "");
          // $scope.pageManager.initSearchParam("contractTypeId", "");
          // initOtherOptionSelections();
          $scope.pageManager.initValidatorsParam();
        };
        initPageManager();

      }
    };
  }
